var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarRatingFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21 34.49-9.308 4.9a3 3 0 0 1-4.354-3.164L9.122 25.86 1.585 18.52a3 3 0 0 1 1.663-5.118l10.41-1.507L18.31 2.46a3 3 0 0 1 5.382 0l4.65 9.436 10.411 1.507a3 3 0 0 1 1.663 5.118l-7.537 7.339 1.784 10.366a3 3 0 0 1-4.354 3.164L21 34.49z",
    fill: "#FFC551",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRatingFilled);
export default __webpack_public_path__ + "static/media/star-rating-filled.059968cbdca100634208d68ac8b964d3.svg";
export { ForwardRef as ReactComponent };